import React, { Component } from 'react';
import   SideNav from "./../../component/sidenav/sidenav.js"
import  Moble from "./../../component/sidenav/moble.js"
import "./newcompany.css"
import TimeAgo from 'react-timeago'
import  AuthService  from "../api/authentication.js";
const Auth = new AuthService();
class NewCampany extends Component {

  constructor(props) {
    super(props)
 
    this.state ={
      noerorrpage :  true,
      hidetemple : false

    }
}

componentDidMount(){
  this.props.noerorrpage(this.state.noerorrpage)


}

selectTemplet=(e)=>{
  e.preventDefault()
  console.log("true select true")
  this.setState({
    hidetemple : true
  })
}
  render() {
    
    return (
        
        
           
                             
          <div>    
             

  

              
            
               <SideNav vanImage={this.props.organizer.image_url}   organizers404={this.props.organizers404} email={this.props.user.email}
                logout={this.logout} name={this.props.user.first_name + " " + this.props.user.last_name}  /> 
                <div className="main">
                   <div className="newcomapany-body">
                     {
                       this.state.hidetemple ?
                       <div></div>
                       :
                       <div>
                          <div className="newcomapany-body-info">
                              Selete tamplet
                            </div>
                          <div className="newcomapany-body-tamplet-body">
                            <ul className="newcomapany-body-tamplet-list">
                                <a onClick={this.selectTemplet}>
                                  <li >
                                    <div className="newcomapany-body-tamplet-img">
                                        <img src="https://res.cloudinary.com/easywaya/image/upload/v1562485796/Screenshot_ckzohw.png" alt=""/>
                                      
                                    </div>
                                    <div className="newcomapany-body-tamplet-para">
                                      
                                         blue business
                                    </div>
                                   
                                  </li>
                                </a>
                            </ul>
                          </div>
                      </div>
                     }

                     <div className="newcomapany-info-body">


                     <div class="columns">
                      <div class="column is-one-third">Company Name:</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" placeholder="Company Name"/>
                            </div>
                          </div>
                      </div>

                      <div class="columns">
                      <div class="column is-one-third">Location of Registration</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" placeholder="Location of Registration"/>
                            </div>
                          </div>
                      </div>

                      <div class="columns">
                      <div class="column is-one-third">City</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" placeholder="City"/>
                            </div>
                          </div>
                      </div>


                      <div class="columns">
                      <div class="column is-one-third">Company Operational Address</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" placeholder="Company Operational Address"/>
                            </div>
                          </div>
                      </div>

                      <div class="columns">
                      <div class="column is-one-third">Year Company Registered</div>
                      <div class="column">
                      <div class="field">
                          <div class="control">
                            <div class="select is-small">
                              <select>
                                <option value="">--- Please select ---</option>
                                <option>With options</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>


                      <div class="columns">
                      <div class="column is-one-third">Total No. Employees:</div>
                      <div class="column">
                        <div class="field">
                          <div class="control">
                            <div class="select is-small">
                              <select>
                                <option value="">--- Please select ---</option>
                                <option>With options</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>

                      <div class="columns">
                      <div class="column is-one-third">Company Website Url if any</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" placeholder="Company Website Url if any"/>
                            </div>
                          </div>
                      </div>


                      <div class="columns">
                      <div class="column is-one-third">Legal Owner:</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" placeholder="Legal Owner"/>
                            </div>
                          </div>
                      </div>


                      
                      <div class="columns">
                          <div class="column is-one-third">Office Size:</div>
                          <div class="column">
                              <div class="field">
                              <div class="control">
                                <div class="select is-small">
                                  <select>
                                    <option value="">--- Please select ---</option>
                                    <option>With options</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>


                      <div class="columns">
                      <div class="column is-one-third">Company Advantages:</div>
                      <div class="column">
                          <div class="control">
                          <textarea class="textarea" placeholder="Company Advantages"></textarea>
                            </div>
                          </div>
                      </div>

                       <div className="newcomapany-info-body-button">
                         <button class="button is-primary">Save</button>
                       </div>

                     </div>
                        
                   </div>

                </div>
              
                            
            {/* <div className="aticle-body-dash-notice">  
                <div className="aticle-sub">  
                    <p className="aticle-date"> <TimeAgo date={this.props.date}/> </p>
                    <i className="fas fa-user-tie icon-link"></i> {this.props.name}
                </div>

                
                <div className="notice-title-body-head">  <p>{this.props.title}</p></div>
                <p>  
                    {this.props.body}
                </p>
                <br/>
                
            </div> */}
          
           </div>                   
                                
                               
                                 
              

    )

}





}

export default NewCampany;


// WEBPACK FOOTER //
// ./src/component/company/newcompany.js